export const potions = [
    {
        name:"Minor Mnemonic Enhancement",
        id:1,
        minLvl: 1,
        type:"mnemonic",
        effect:"Restore 1d6+1 spell points"
    },
    {
        name:"Lesser Mnemonic Enhancement",
        type:"mnemonic", 
        id:2,
        minLvl: 2,
        effect:"Restore 2d6+3 spell points"
    },
    {
        name:"Moderate Mnemonic Enhancement",
        type:"mnemonic", 
        id:3,
        minLvl: 3,
        effect:"Restore 3d6+5 spell points"
    },
    {
        name:"Improved Mnemonic Enhancement",
        type:"mnemonic", 
        id:4,
        minLvl: 4,
        effect:"Restore 4d6+7 spell points and 1 point of damage to a single mental stat or spell regen 1 for 3 rounds"
    },
    {
        name:"Greater Mnemonic Enhancement",
        type:"mnemonic", 
        id:5,
        minLvl: 5,
        effect:"Restore 4d8+9 spell points and 1d3 points of damage to a single mental stat or spell regen 3 for 3 rounds"
    },
    {
        name:"Epic Mnemonic Enhancement",
        type:"mnemonic", 
        id:6,
        minLvl: 6,
        effect:"Restore 6d6+12 spell points and 1d6 damage to a single mental stat or spell regen 5 for 3 rounds"
    },
    {
        name:"Legendary Mnemonic Enhancement",
        type:"mnemonic", 
        id:7,
        minLvl: 7,
        effect:"Restore 10d6+15 spell points and 2d4 damage to a single mental stat or 1d3 to all mental stats or spell regen 7 for 3 rounds"
    },
    {
        name:"Mythic Mnemonic Enhancement",
        type:"mnemonic", 
        id:8,
        minLvl: 8,
        effect:"Restore 16d6+30 spell points and all damage to a single mental stat or 1d6 to all mental or stats spell regen 10 for 3 rounds"
    },
    {
        name:"Ether",
        type:"mnemonic", 
        id:9,
        minLvl: 9,
        effect:"Restore all of your spell points and damage to all mental stats or spell regen 15 for 3 rounds"
    },
    {
        name:"Cure Minor Wounds",
        type:"curative", 
        id:10,
        minLvl: 1,
        effect:"Restore 1d8+3 hit points"
    },
    {
        name:"Cure Light Wounds",
        type:"curative", 
        id:11,
        minLvl: 2,
        effect:"Restore 2d8+3 hit points"
    },
    {
        name:"Cure Moderate Wounds",
        type:"curative", 
        id:12,
        minLvl: 3,
        effect:"Restore 4d8+5 hit points"
    },
    {
        name:"Cure Serious Wounds",
        type:"curative", 
        id:13,
        minLvl: 4,
        effect:"Restore 6d8+7 hit points, and 1 point of damage to a single physical stat or fast healing 1 for 5 rounds"
    },
    {
        name:"Cure Critical Wounds",
        type:"curative", 
        id:14,
        minLvl: 5,
        effect:"Restore 8d8+10 hit points and 1d3 damage to a single physical stat or fast healing 3 for 5 rounds"
    },
    {
        name:"Cure Devistating Wounds",
        type:"curative", 
        id:15,
        minLvl: 6,
        effect:"Restore 12d8+20 hit points and 1d6 damage to a single physical stat or fast healing 5 for 5 rounds"
    },
    {
        name:"Legendary Bodily Repair",
        type:"curative", 
        id:16,
        minLvl: 7,
        effect:"Restore 16d8+30 hit points and 2d4 to a single physical stat or 1d3 to all physical stats or fast healing 7 for 5 rounds"
    },
    {
        name:"Mythic Bodily Repair",
        type:"curative", 
        id:17,
        minLvl: 8,
        effect:"Restore 24d8+45 hit points and all damage to a single physical stat or 1d6 to all physical stats or fast healing 10 for 5 rounds"
    },
    {
        name:"Elixer",
        type:"curative", 
        id:18,
        minLvl: 9,
        effect:"Restore all hit points and all damage to all physical stats or fast healing 15 for 5 rounds"
    },
    {
        name:"Lesser Restoration",
        type:"restorative", 
        id:19,
        minLvl: 1,
        effect:"Restore 1d4 damage to a single stat, or 1 to two stats, or allows the player to make a save against a temporary negative level to remove it. Improves exhausted and fatigued by 1 step."
    },
    {
        name:"Moderate Restoration",
        type:"restorative", 
        id:20,
        minLvl: 3,
        effect:"Restore 2d4 damage to a single stat, or 1d4 to two stats, or 1 to all stats, or 1d4 points of drain from a single score, or a temporary negative level, or allows a save vs a permanent negative level. Cures exhausted and fatigued."
    },
    {
        name:"Greater Restoration",
        type:"restorative", 
        id:21,
        minLvl: 5,
        effect:"Restore all damage to a single stat, or 2d4 to two stats, or 1d4 to all stats, or 1d8 points of drain from a single score, or all temporary negative levels, or 1 permanent negative level, Cures exhausted and fatigued."
    },
    {
        name:"Complete Restoration",
        type:"restorative", 
        id:22,
        minLvl: 8,
        effect:"Restore all damage to all stats, or all drain from one stat, or all negative levels, also cures exhausted and fatigued"
    },
    {
        name:"Remove Curse",
        type:"restorative", 
        id:23,
        minLvl: 1,
        effect:"Remove a single curse"
    },
    {
        name:"Remove Blindness/Deafness",
        type:"restorative", 
        id:24,
        minLvl: 1,
        effect:"Cures either blindness or deafness"
    },
    {
        name:"Remove Sickness",
        type:"restorative", 
        id:25,
        minLvl: 1,
        effect:"Remove a single sickened, nausea, or disease condition. This potion can be drank when nauseated as a movement action."
    },
    {
        name:"Remove Poison",
        type:"restorative", 
        id:26,
        minLvl: 1,
        effect:"Remove a poison currently affecting the target."
    },
    {
        name:"Remove Paralysis",
        type:"restorative", 
        id:27,
        minLvl: 1,
        effect:"Remove a single paralysis, slow, staggered, or stunned condition."
    },
    {
        name:"Clear Mind",
        type:"restorative", 
        id:28,
        minLvl: 1,
        effect:"Remove a single mental affect, such as a fear, domination, or charm effect."
    },
    {
        name:"Dispelling",
        type:"restorative", 
        id:29,
        minLvl: 3,
        effect:"Remove a single spell affecting a target, can be thrown at a spell effect to cast dispel magic at current level."
    },
    {
        name:"Panacea",
        type:"restorative", 
        id:30,
        minLvl: 5,
        effect:"Removes a single negative condition another restorative potion could except permanent negative levels, ability score damage, or drain."
    },
    {
        name:"Angels Tears",
        type:"restorative", 
        id:31,
        minLvl: 7,
        effect:"Restore all hit points and spell points"
    },
    {
        name:"Divine Essence",
        type:"restorative", 
        id:32,
        minLvl: 9,
        effect:"Restore all hit points, spell points, and remove all negative effects and conditions on the target, but it will only remove 1 permanent negative level at a time."
    },
    {
        name:'Gem of Breathe of life',
        id:33,
        minLvl: 1,
        effect:"Cast breath of life with your level as your caster level",
        type:"ressurective",
    },
    {
        name:'Gem of Raise Dead',
        id:34,
        minLvl: 3,
        effect:"Cast Raise dead with your level as your caster level",
        type:"ressurective",
    },
    {
        name:'Gem of Ressurection',
        id:35,
        minLvl: 5,
        effect:"Cast Ressurection with your level as your caster level",
        type:"ressurective",
    },
    {
        name:'Gem of True Ressurection',
        id:36,
        minLvl: 7,
        effect:"Cast True Ressurection with your level as your caster level",
        type:"ressurective",
    },        
]